export const isObject = (item: unknown): boolean => {
  return !!item && typeof item === "object" && !Array.isArray(item);
};

export const mergeDeep = <T extends Record<string, unknown>>(
  target: T,
  ...sources: T[]
): T => {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        mergeDeep(target[key] as T, source[key] as T);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
};
